<!-- This file is not localized on purpose as it's a DE-only integration -->

<form [formGroup]="group" layout-vertical>
  <div layout-horizontal margin-bottom>
    @if (!!group.get('countryCode')) {
      <rt-form-field class="address-form-field" margin-right>
        <rt-label>Land</rt-label>
        <rt-select
          formControlName="countryCode"
          [options]="countryCodeSelectOptions"
          [hasSearch]="true"
          [includeEmptyOption]="false"
        >
        </rt-select>
      </rt-form-field>
    }

    @if (!!group.get('postalCode')) {
      <rt-form-field class="address-form-field" margin-right>
        <rt-label>Postleitzahl</rt-label>
        <rt-input variant="rounded" formControlName="postalCode"></rt-input>
      </rt-form-field>
    }

    @if (!!group.get('region') && !addressValidationEnabled()) {
      <rt-form-field class="address-form-field">
        <rt-label>Region</rt-label>
        <rt-select
          formControlName="region"
          [disabled]="!group.value.countryCode || !regionSelectOptions.length"
          [options]="regionSelectOptions"
          [hasSearch]="true"
          [includeEmptyOption]="false"
        >
        </rt-select>
      </rt-form-field>
    }

    @if (!!group.get('region') && addressValidationEnabled()) {
      <rt-form-field class="address-form-field">
        <rt-label>Region</rt-label>
        <rt-select
          formControlName="region"
          [options]="regionSelectOptions"
          [hasSearch]="false"
          [disabled]="addressesLoading || !group.value.postalCode || !regionSelectOptions.length"
          [includeEmptyOption]="false"
        >
        </rt-select>
      </rt-form-field>
    }
  </div>

  <div layout-horizontal>
    @if (!!group.get('municipality') && !addressValidationEnabled()) {
      <rt-form-field class="address-form-field" margin-right>
        <rt-label>Stadt</rt-label>
        <rt-input variant="rounded" formControlName="municipality"></rt-input>
      </rt-form-field>
    }
    @if (!!group.get('municipality') && addressValidationEnabled()) {
      <rt-form-field class="address-form-field" margin-right>
        <rt-label>Stadt</rt-label>
        <rt-select
          formControlName="municipality"
          [options]="citySelectOptions"
          [hasSearch]="false"
          [disabled]="addressesLoading || !group.value.postalCode || !citySelectOptions.length"
          [includeEmptyOption]="false"
        >
        </rt-select>
      </rt-form-field>
    }

    @if (!!group.get('streetName')) {
      <rt-form-field class="address-form-field" margin-left>
        <rt-label>Straße</rt-label>
        <rt-input variant="rounded" formControlName="streetName"></rt-input>
        @if (group.controls.streetName.value?.length > STREET_NAME_MAX_LENGTH) {
          <div class="length-error">
            {{ 'rti.common.maximum_characters' | translate: { count: STREET_NAME_MAX_LENGTH } }}
          </div>
        }
      </rt-form-field>
    }
  </div>
</form>
